// 削除要望対応（GDPR/DSA） API
// 対応ルーター: backend/routers/ugc_compliance.py

export const UGCComplianceApiPath = {
  GET_DELETE_PREVIEW:
    '/api/sites/{site_id}/ugc/compliance/delete-preview?user_identifier={user_identifier}',
  DELETE_REQUEST: '/api/sites/{site_id}/ugc/compliance/delete-request',
  GET_CONSENT_SUMMARY: '/api/sites/{site_id}/ugc/compliance/consent-summary'
} as const

export interface DeletePreviewVars {
  site_id: number
  user_identifier: string
}

/** 削除の前に「何が消えるか」を見せるための一覧。取得しても何も変更されない */
export interface DeletePreviewResponse {
  identifier_masked: string
  /** email=メールアドレスで一致 / name=お名前（敬称・空白を除いて一致）。name は同姓同名に注意 */
  matched_by?: 'email' | 'name'
  total: number
  ugc_items: {
    id: number
    source_type: string | null
    caption: string
    created_at: string | null
  }[]
  reviews: {
    id: number
    rating: number | null
    title: string
    created_at: string | null
  }[]
  mail_requests: {
    id: number
    product_name: string | null
    order_id: string | null
    created_at: string | null
  }[]
}

export interface DeleteRequestVars {
  site_id: number
  user_identifier: string
}

export interface DeleteRequestResponse {
  ok: boolean
  total_affected: number
  detail: { ugc_items: number; reviews: number; mail_requests: number }
  completed_at: string
}

export interface ConsentSummaryVars {
  site_id: number
}

export interface ConsentSummaryResponse {
  total: number
  granted: number
  pending: number
  denied: number
  grant_rate: number
}
